import React, { FC } from 'react';

import { MarginProps } from '@opendoor/bricks/system/theme';

import { Section } from 'shared/components/Section';
import { formatTaskCardDue, TaskCardProps } from 'shared/components/TaskCard';
import { TasksSectionContent } from 'shared/components/TasksSectionContent';

import { getHubLateCheckoutWizardRoute } from 'shared/helpers/routes';
import { UnderContractOffer } from 'sellDirect/OfferContext';
import { getClosingChangeCloseDateRoute } from 'sellDirect/routes/SellDirectClosingRouter';

interface OptionalClosingTasksProps {
  offer: UnderContractOffer;
}

/**
 * Renders optional closing tasks section (Change close date and request late checkout)
 *
 * @todo Javi - Update how to handle when the user cannot do one of these tasks once Gavin/Robbie/Lauren give us a definitive answer
 *
 * component-test-check-ignore
 */
export const OptionalClosingTasksSection: FC<OptionalClosingTasksProps & MarginProps> = ({
  offer,
  ...marginProps
}) => {
  const tasks: TaskCardProps[] = [];

  if (offer.canChangeCloseEscrowDate) {
    tasks.push({
      analyticsName: 'change-close-date',
      title: 'Change close date',
      /** @todo Javi - Change this for `deadline` once it's available in bricks */
      due: formatTaskCardDue(offer.changeCloseEscrowDateDeadline),
      url: getClosingChangeCloseDateRoute(),
    });
  }
  if (offer.canScheduleLateCheckout) {
    tasks.push({
      analyticsName: 'request-late-checkout',
      title: 'Request late checkout',
      /** @todo Javi - Change this for `deadline` once it's available in bricks */
      due: formatTaskCardDue(offer.scheduleLateCheckoutDeadline.toLocalDate()),
      url: getHubLateCheckoutWizardRoute(),
    });
  }

  if (tasks.length === 0) return null;

  return (
    <Section title="Optional" {...marginProps}>
      <TasksSectionContent tasks={tasks} preferredLayout="row" />
    </Section>
  );
};
